import React, { useEffect, useState } from 'react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Tooltip from '@mui/material/Tooltip';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { Box, Typography } from '@mui/material';
const statCards = [

  {
    title: 'Today’s Worked Time',
    value: '8h 05m',
    change: '15%',
    changeType: 'positive',
    tooltip: 'Average active time spent per user.',
  },
  {
    title: 'Today’s Activity',
    value: '46%',
    change: '15%',
    changeType: 'negative',
    tooltip: 'Total mouse and keyboard activity',
  },
  {
    title: 'Worked This Week',
    value: '32h 30m',
    change: '15%',
    changeType: 'positive',
    tooltip: 'Average Time users are active without any idle periods.',
  },
  {
    title: 'Weekly Activity',
    value: '52%',
    change: '15%',
    changeType: 'positive',
    tooltip: 'Calculated by dividing the total mouse and keyboard activity by the total time',
  },
  {
    title: 'Today’s. Idle Time',
    value: '1h 20m',
    change: '15%',
    changeType: 'positive',
    tooltip: 'Average time without keyboard or mouse activity during work hours.',
  },
  {
    title: 'Total Projects Worked',
    value: '150',
    change: '15%',
    changeType: 'positive',
    tooltip: 'Total number of projects with activity recorded today.',
  },
  {
    title: 'Earned Today',
    value: '$0.00',
    change: ' 00%',
    changeType: 'positive',
    tooltip: 'Active Users are users who have recorded any activity today',
  },
];


const MeHeaderStats = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="row gy-0">
      <div className="col-xxl-12 d-flex flex-wrap gap-2">
        {
          loading ? (
            statCards.map((_) => (
              <Box
                className="card-body p-20 bg-base border d-flex flex-column justify-content-center rounded-3"
                sx={{ flex: '1 1 210px', minWidth: '210px' }}
              >
                <Stack spacing={1}>
                  <Skeleton variant="text" width="60%" sx={{ fontSize: '1rem' }} />
                  <Skeleton variant="text" width="40%" />
                  <Skeleton variant="rectangular" width="100%" height={40} />
                </Stack>
              </Box>
            ))
          ) : (
            statCards.map((stat, index) => (
              <>
                <Box
                  sx={{ flex: '1 1 210px', minWidth: '210px' }}
                  key={index}
                  className="card-body p-20 bg-base border d-flex flex-column justify-content-center rounded-3"
                >
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                    <div>
                      <span className="mb-1 fw-medium text-secondary-light text-sm">
                        {stat.title}
                      </span>

                      <Typography variant='h6' className="fw-semibold text-primary-light mb-1">
                        {stat.value}
                        {stat.subValue && (
                          <sub className="text-sm ms-1">{stat.subValue}</sub>
                        )}
                      </Typography>
                    </div>
                  </div>
                  <div className="text-sm mb-0">
                    <span
                      className={`px-1 rounded-2 fw-medium text-sm ${stat.changeType === 'positive'
                        ? 'text-success-main'
                        : 'text-danger-main'
                        }`}
                    >
                      {stat.change}
                    </span>{' '}
                    <p className="text-xs mb-0 d-flex justify-content-between align-items-center">
                      compared to previous days
                      <Tooltip title={stat.tooltip} arrow placement="top">
                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                          <InfoOutlineIcon fontSize="small" />
                        </button>
                      </Tooltip>
                    </p>
                  </div>
                </Box >
              </>
            ))
          )
        }
      </div>
    </div >
  );
};

export default MeHeaderStats;

